<div id="au_app_header" class="app-header">
    <div class="app-container container-xxl d-flex align-items-stretch justify-content-between" id="au_app_header_container">
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">  <img alt="Logo" src="assets/media/logos/alchemy-logo.png" class="h-60px h-lg-60px" draggable="false" (click)="navigate()"/> </div>
      <div class="app-header-menu app-header-mobile-drawer align-items-stretch">
        <div class="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0" id="au_app_header_menu" data-au-menu="true">
          @if(isUwAdmin() || isSysAdmin() || isBroker()) {
          <div class="menu-item menu-here-bg me-0 me-lg-2"> <span class="menu-link"><span class="menu-title" (click)="navigate()">Dashboard</span><span class="menu-arrow d-lg-none"></span></span> </div>
          }
          @if(isUwAdmin() || isBroker()) {
          <div class="menu-item me-0 me-lg-2"> <span class="menu-link"><span class="menu-title">Manage Policy</span><span class="menu-arrow d-lg-none"></span></span> </div>
          }
          @if(isBroker()) {
          <div class="menu-item"> <span class="menu-link"><span class="menu-title">Resources</span><span class="menu-arrow d-lg-none"></span></span> </div>
          }
          <!------------- TODO: remove this below form commiting code Policy Document generation link --------------->
          <!-- <div class="menu-item"> <span class="menu-link"><span class="menu-title" (click)="moveToPolicyDocument()">Policy Document</span><span class="menu-arrow d-lg-none"></span></span> </div> -->
        </div>
      </div>
      <div class="app-navbar flex-shrink-0">
        <div class="app-navbar-item align-items-stretch ms-1 ms-lg-3">
          <div
            id="au_header_search"
            class="header-search d-flex align-items-stretch"
            data-au-search-keypress="true"
            data-au-search-min-length="2"
            data-au-search-enter="enter"
            data-au-search-layout="menu"
            data-au-menu-trigger="auto"
            data-au-menu-overflow="false"
            data-au-menu-permanent="true"
            data-au-menu-placement="bottom-end"
            data-au-search="true"
            >
            <!--<div class="d-flex align-items-center" data-au-search-element="toggle" id="au_header_search_toggle">
              <div class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px"> <i class="bi bi-search fs-1 text-muted"></i> </div>
            </div> -->
            <div data-au-search-element="content" class="menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px" data-au-menu="true">
              <div data-au-search-element="wrapper">
                <form data-au-search-element="form" class="w-100 position-relative mb-3" autocomplete="off">
                  <i class="bi bi-search fs-2 text-gray-500 position-absolute top-50 translate-middle-y ms-0"></i>
                  <input type="text" class="search-input form-control form-control-flush ps-10" name="search" value="" placeholder="Search..." data-au-search-element="input" />
                  <span class="search-spinner position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-1" data-au-search-element="spinner"> <span class="spinner-border h-15px w-15px align-middle text-gray-500"></span> </span> <span class="search-reset btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none" data-au-search-element="clear"> <i class="bi bi-x fs-2 fs-lg-1 me-0"></i> </span>
                  <div class="position-absolute top-50 end-0 translate-middle-y" data-au-search-element="toolbar">
                    <div
                                                      data-au-search-element="preferences-show"
                                                      class="btn btn-icon w-20px btn-sm btn-active-color-primary me-1"
                                                      data-bs-toggle="tooltip"
                                                      aria-label="Show search preferences"
                                                      data-bs-original-title="Show search preferences"
                                                      data-au-initialized="1"
                                                  > <i class="bi bi-gear fs-2"></i> </div>
                    <div
                                                      data-au-search-element="advanced-options-form-show"
                                                      class="btn btn-icon w-20px btn-sm btn-active-color-primary"
                                                      data-bs-toggle="tooltip"
                                                      aria-label="Show more search options"
                                                      data-bs-original-title="Show more search options"
                                                      data-au-initialized="1"
                                                  > <i class="ki-duotone ki-down fs-2"></i> </div>
                  </div>
                </form>
                <div class="separator border-gray-200 mb-6"></div>
                <div data-au-search-element="empty" class="text-center d-none">
                  <div class="pt-10 pb-10"> <i class="ki-duotone ki-search-list fs-4x opacity-50"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i> </div>
                  <div class="pb-15 fw-semibold">
                    <h3 class="text-gray-600 fs-5 mb-2">No result found</h3>
                    <div class="text-muted fs-7">Please try again with a different query</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="app-navbar-item ms-1 ms-lg-3 d-flex align-items-center d-none d-md-flex right">
          <span class="text-muted fs-7 me-2">Require assistance? Contact <u><a href="mailto:Help&#64;abacusAU.com" class="text-primary text-hover-underline" draggable="false">Help&#64;abacusAU.com</a></u></span>
        </div>
        <div class="app-navbar-item ms-1 ms-lg-3">
          <div
          class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px"
          (click)="toggleNotifications()"
          data-au-menu-trigger="{default: 'click', lg: 'hover'}"
          data-au-menu-attach="parent"
          data-au-menu-placement="bottom-end"
      >
          <i class="bi bi-bell fs-1 text-muted"></i>
      </div>
      
      <div
          class="menus menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-300px"
          [ngClass]="{ 'show': notificationsOpen }"
          data-au-menu="true"
          style=""
      >
      </div>
  
          <!-- <div class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px" data-au-menu="true" id="au_menu_notifications" style="">
            <div class="d-flex flex-column bgi-no-repeat rounded-top" style="background-image: url('assets/media/misc/menu-header-bg.jpg');">
              <h3 class="text-white fw-semibold px-9 mt-10 mb-6">Notifications <span class="fs-8 opacity-75 ps-3">24 reports</span></h3>
              <ul class="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-semibold px-9" role="tablist">
                <li class="nav-item" role="presentation"> <a class="nav-link text-white opacity-75 opacity-state-100 pb-4" data-bs-toggle="tab" href="#au_topbar_notifications_1" aria-selected="false" tabindex="-1" role="tab" draggable="false">Alerts</a> </li>
              </ul>
            </div>
            <div class="tab-content">
              <div class="tab-pane fade" id="au_topbar_notifications_1" role="tabpanel">
                <div class="scroll-y mh-325px my-5 px-8">
                  <div class="d-flex flex-stack py-4">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-35px me-4"> <span class="symbol-label bg-light-primary"> <i class="ki-duotone ki-abstract-28 fs-2 text-primary"><span class="path1"></span><span class="path2"></span></i> </span> </div>
                      <div class="mb-0 me-2"> <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold" draggable="false">Project Alice</a>
                        <div class="text-gray-500 fs-7">Phase 1 development</div>
                      </div>
                    </div>
                    <span class="badge badge-light fs-8">1 hr</span> </div>
                  <div class="d-flex flex-stack py-4">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-35px me-4"> <span class="symbol-label bg-light-danger"> <i class="ki-duotone ki-information fs-2 text-danger"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i> </span> </div>
                      <div class="mb-0 me-2"> <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold" draggable="false">Confidential</a>
                        <div class="text-gray-500 fs-7">Confidential staff documents</div>
                      </div>
                    </div>
                    <span class="badge badge-light fs-8">2 hrs</span> </div>
                  <div class="d-flex flex-stack py-4">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-35px me-4"> <span class="symbol-label bg-light-warning"> <i class="ki-duotone ki-color-swatch fs-2 text-warning"> <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span> <span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span> <span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span> <span class="path19"></span><span class="path20"></span><span class="path21"></span> </i> </span> </div>
                      <div class="mb-0 me-2"> <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bold" draggable="false">Icon Assets</a>
                        <div class="text-gray-500 fs-7">Collection of SVG icons</div>
                      </div>
                    </div>
                    <span class="badge badge-light fs-8">20 March</span> </div>
                </div>
                <div class="py-3 text-center border-top"> <a href="#" class="btn btn-color-gray-600 btn-active-color-primary" draggable="false"> View All <i class="ki-duotone ki-arrow-right fs-5"><span class="path1"></span><span class="path2"></span></i> </a> </div>
              </div>
            </div>
          </div> -->
        </div>
       
        <div class="app-navbar-item ms-2 ms-1 ms-lg-3" id="au_header_user_menu_toggle"   (mouseenter)="openMenu()" (mouseleave)="closeMenu()">
          <div class="cursor-pointer symbol symbol-35px symbol-md-40px menus-container" (click)="toggleMenu()" data-au-menu-trigger="{default: 'click', lg: 'hover'}" data-au-menu-attach="parent" data-au-menu-placement="bottom-end">             
            <div id="profile">
              {{ initials }}
            </div>  
            <div class="menus menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" [ngClass]="{ 'show': menuOpen }" (mouseenter)="openMenu()" (mouseleave)="closeMenu()" data-au-menu="true" style="">
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <div class="symbol symbol-50px me-5"> 
                    <div id="profile">
                      {{ initials }}
                    </div>               
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fw-bold d-flex align-items-center fs-5">
                      <div style="display: inline-block; max-width: 95px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
                      {{ fullName }} 
                      </div>
                      <span class="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">{{ roleName }}</span>
                    </div>
                    <a href="#" class="fw-semibold text-muted text-hover-primary fs-7" style="display: inline-block; max-width: 150px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;" draggable="false">
                      {{ email }}
                    </a>
                  </div>
                  
              </div>
              <div class="separator my-2"></div>
              <div class="menu-item px-5"> <p class="menu-link px-5"> My Profile </p> </div>
              <div class="separator my-2"></div>
              <!-- <div class="menu-item px-5 my-1"> <a href="#" class="menu-link px-5"> Account Settings </a> </div> -->
              <div class="menu-item px-5"> <p class="menu-link px-5" (click)="logOut()"> Sign Out </p> </div>
            </div>
            </div>
          </div>
        <div class="app-navbar-item d-lg-none ms-2 me-n2" title="Show header menu">
          <div class="btn btn-flex btn-icon btn-active-color-primary w-30px h-30px" id="au_app_header_menu_toggle"> <i class="ki-duotone ki-element-4 fs-1"><span class="path1"></span><span class="path2"></span></i> </div>
        </div>
      </div>
    </div>
  </div>